
import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import PasswordForm from "@/components/forms/components/PasswordForm.vue";
import MemberService from "@/services/members";
import Cognito from "@/plugins/cognito";

@Component({
  name: "ResetPassword",
  components: {
    Header,
    Footer,
    PasswordForm,
  },
})
export default class ResetPassword extends Vue {
  private password = "";
  private confirmPassword = "";
  private verificationCode = "";
  private id = this.$route.query.code as string;
  private email = "";
  private loading = false;
  private showPass = false;
  private showPassConfirm = false;
  private showLabel = false;
  private showError() {
    this.showLabel = true;
    setTimeout(() => {
      this.showLabel = false;
    }, 3000);
  }

  private async mounted() {
    try {
      if (this.id) {
        const res = await MemberService.getResetPasswordInfo(this.id);
        this.email = res.data.data[0].email;
      }
    } catch (error: any) {
      throw new Error(error);
    }
  }

  private async submit() {
    try {
      this.loading = true;
      await Cognito.resetPassword(this.email, this.password, this.verificationCode);
      this.$router.push({ name: "ResetPasswordComplete" });
      this.loading = false;
    } catch (error: any) {
      this.loading = false;
      this.showError();
      throw new Error(error);
    }
  }

  private passwordToggle() {
    this.showPass = !this.showPass;
  }
  private confirmPasswordToggle() {
    this.showPassConfirm = !this.showPassConfirm;
  }
}
